import { ApexOptions } from "apexcharts";
import moment from "moment";
import { theme } from "nectar-ui";
import { DASHBOARD_CHART_TYPES } from "@utils/constants/dashboard/dashboardModuleConstants";
import {
  apexChartInvertedSeriesClickHandler,
  getXAxisTooltipFormatterBasedOnRange,
} from "@utils/helpers/dashboardHelpers";
import { ChartGroups } from "@customTypes/chart";

export const getSeriesNames = () => ({
  createdArrayName: "Cadastrados",
  endedArrayName: "Encerrados",
});

export const getChartOptions = (
  xaxis: string[],
  groups: ChartGroups,
  rangeFilter: string
): ApexOptions => ({
  chart: {
    id: DASHBOARD_CHART_TYPES.LAWSUIT_TRACKER.chart,
    height: 350,
    type: "line",
    fontFamily: theme.nectar.fontStack.default,
    toolbar: {
      show: false,
    },
    events: {
      legendClick: apexChartInvertedSeriesClickHandler,
    },
    zoom: {
      enabled: false,
    },
  },
  colors: [theme.nectar.colors.blue500, theme.nectar.colors.primary800],
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "straight",
    width: 3,
    dashArray: [0, 5],
  },
  grid: {
    borderColor: "#DEE2E6",
    position: "back",
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: true,
      },
    },
  },
  legend: {
    itemMargin: {
      horizontal: 8,
      vertical: 8,
    },
    onItemClick: {
      toggleDataSeries: false,
    },
    markers: {
      width: 16,
      height: 16,
      radius: 2,
    },
  },
  yaxis: {
    labels: {
      formatter: (val) => {
        return Math.round(val).toString();
      },
      style: {
        fontSize: "14px",
        fontWeight: 300,
        colors: theme.nectar.colors.gray500,
      },
    },
  },
  xaxis: {
    categories: xaxis,
    tickAmount: 15,
    tickPlacement: "between",
    labels: {
      hideOverlappingLabels: false,
      rotate: 0,
      rotateAlways: false,
      style: {
        fontSize: "14px",
        fontWeight: 300,
        colors: theme.nectar.colors.gray500,
      },
      formatter: (date) => {
        const [dayString, monthString] = moment(date, "YYYY-MM-DD").format("D MMM").split(" ");
        const formattedMonthString = monthString.charAt(0).toUpperCase() + monthString.substring(1);

        if (rangeFilter === "LAST_YEAR") return formattedMonthString;
        return `${dayString} ${formattedMonthString}`;
      },
    },
    group: {
      groups,
      style: {
        fontSize: "14px",
        fontWeight: 300,
        colors: theme.nectar.colors.gray500,
      },
    },
  },
  tooltip: {
    x: {
      formatter: getXAxisTooltipFormatterBasedOnRange,
    },
  },
  responsive: [
    {
      breakpoint: 768,
      options: {
        xaxis: {
          tickAmount: 5,
        },
      },
    },
  ],
});
